import { Button } from './ui/button';
import { Card } from './ui/card';
import { CircleAlert } from 'lucide-react';
import Link from 'next/link';

type EmptyStateProps = {
    title: string;
    message: string;
    description?: string;
    icon?: React.ElementType;
    cta?: { href: string; label: string };
};

export function EmptyState({ title, message, description, icon: Icon, cta }: EmptyStateProps) {
    return (
        <Card className="p-8 flex flex-col items-center text-center gap-4 w-full overflow-hidden">
            {Icon ? (
                <Icon className="h-10 w-10 text-muted-foreground shrink-0" />
            ) : (
                <CircleAlert className="h-10 w-10 text-muted-foreground shrink-0" />
            )}
            <div className="w-full">
                <h3 className="text-xl font-semibold break-words">{title}</h3>
                <p className="text-sm text-muted-foreground mt-2 max-w-prose mx-auto break-words">{message}</p>
                {description && (
                    <p className="text-sm text-muted-foreground mt-2 max-w-prose">{description}</p>
                )}
            </div>
            {cta && (
                <Button asChild>
                    <Link href={cta.href}>{cta.label}</Link>
                </Button>
            )}
        </Card>
    );
}



